// docs: https://github.com/altostra/type-validations#readme
import { objectOf, anyOf } from "@altostra/type-validations";
import { boolean, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiBrandGuidelineResult = objectOf({
  id: string,
  name: string,
  app_group_id: string,
  guideline_purpose: anyOf(string, nullOrUndefined),
  description: anyOf(string, nullOrUndefined),
  brand_personality: string,
  exclusions: anyOf(string, nullOrUndefined),
  tone_type: anyOf(string, nullOrUndefined),
  is_default: anyOf(boolean, nullOrUndefined),
  updated_at: anyOf(string, nullOrUndefined),
  status: anyOf(string, nullOrUndefined),
  type: anyOf(string, nullOrUndefined),
  last_edited_by_id: anyOf(string, nullOrUndefined),
});
